import type React from 'react';

import * as st from './styles.module.scss';

interface Props {
	children: React.ReactNode;
}

export const Week: React.FC<Props> = ({ children }) => {
	return <div className={st.week}>{children}</div>;
};
